import { useState, useEffect } from "react";
import axios from "axios";
import { Instagram, Youtube } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const API = process.env.REACT_APP_BACKEND_URL;

const LABELS = {
  de: { youtube: "Abonnenten auf YouTube", instagram: "Follower auf Instagram" },
  en: { youtube: "subscribers on YouTube", instagram: "followers on Instagram" },
  es: { youtube: "suscriptores en YouTube", instagram: "seguidores en Instagram" },
  it: { youtube: "iscritti su YouTube", instagram: "follower su Instagram" },
  fr: { youtube: "abonnés sur YouTube", instagram: "abonnés sur Instagram" },
};
const ICONS = { youtube: Youtube, instagram: Instagram };

const fmt = (n) => {
  const floored = n >= 1000 ? Math.floor(n / 100) * 100 : Math.floor(n / 10) * 10;
  return `${floored.toLocaleString("de-CH")}+`;
};

export const SocialProofBar = () => {
  const { lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/social/stats`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  if (!items.length) return null;
  const labels = LABELS[lang] || LABELS.de;

  return (
    <div className="mx-auto max-w-7xl px-5 sm:px-8" data-testid="social-proof-bar">
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 border-y py-5"
        style={{ borderColor: "var(--line)" }}>
        {items.map(({ platform, count }) => {
          const Icon = ICONS[platform];
          return (
            <div key={platform} className="flex items-center gap-2.5 text-sm" data-testid={`social-proof-${platform}`}>
              <Icon size={16} strokeWidth={1.6} style={{ color: "var(--camel)" }} />
              <span className="font-serif-display text-base font-semibold">{fmt(count)}</span>
              <span style={{ color: "var(--muted-warm)" }}>{labels[platform]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
